import Axios from '../Helpers/axios.js';
import Swal from 'sweetalert2';

export const iniciarMenu = async () => {
    try
    {
        const respuesta = await Axios({
            url : 'Menu/iniciarMenu',
            method : 'GET'
        })

        const {data} = respuesta;

        return data;
    }
    catch(e)
    {
        Swal.fire('Oops!', 'Ha ocurrido un problema al cargar el menu, por favor actualiza la pagina.', 'error');
        return false;
    }
}